// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Acquisition Store API
 * API for managing acquisition in-store.
 * OpenAPI spec version: 1.0.0
 */

/**
 * Roles to grant this companion session.
 *
 * Possible values:
 * - file_sync (FILE_SYNC)
 * - barcode_scanner (BARCODE_SCANNER)
 * - offer_create (OFFER_CREATE)
 * - offer_display (OFFER_DISPLAY)
 */
export type CompanionRole = typeof CompanionRole[keyof typeof CompanionRole];


export const CompanionRole = {
  FILE_SYNC: 'file_sync',
  BARCODE_SCANNER: 'barcode_scanner',
  OFFER_CREATE: 'offer_create',
  OFFER_DISPLAY: 'offer_display',
} as const;
